// Los correos del HOGAR de un cliente: el conyuge y los dependientes que
// tienen direccion propia (Lissette 2026-09-02, queja 16 — poder copiarlos
// cuando se le escribe al titular).
//
// Es la MISMA lista que el backend acepta como copia en
// POST /clients/:id/emails: la del expediente y nada mas. Si aqui se ofreciera
// una direccion que alla no esta en la lista blanca, el envio se caeria con
// CC_NOT_IN_HOUSEHOLD y el agente no entenderia por que.
//
// Ojo, no se filtra por `maritalStatus` ni por `separateProfile`: eso lo usa
// la parte de POLIZAS para decidir a quien se asegura (ver hasCurrentSpouse /
// enumerateInsuredMembers en policyTypes.js), que es otra pregunta. Aqui la
// pregunta es "a quien de esta ficha se le puede escribir", y la respuesta es
// cualquiera que tenga correo puesto, igual que en el servidor.

const limpio = (e) => (typeof e === 'string' ? e.trim() : '');
const esCorreo = (e) => limpio(e).includes('@');

/**
 * @param {object} client  ficha en el formato del SPA (client.spouse, client.dependents)
 * @param {'es'|'en'} lang para el parentesco que se ensena al lado del nombre
 * @returns {Array<{key:string, email:string, nombre:string, parentesco:string}>}
 *          sin el titular, sin repetidos y sin direcciones vacias.
 */
export function miembrosDelHogarConCorreo(client, lang = 'es') {
  if (!client) return [];
  const es = lang !== 'en';
  const fuera = new Set();
  const propio = limpio(client.email).toLowerCase();
  if (propio) fuera.add(propio);

  const salida = [];
  const meter = (key, email, nombre, parentesco) => {
    const dir = limpio(email);
    if (!esCorreo(dir)) return;
    const norm = dir.toLowerCase();
    if (fuera.has(norm)) return;
    fuera.add(norm);
    salida.push({ key, email: dir, nombre: (nombre || '').trim() || dir, parentesco });
  };

  const sp = client.spouse || {};
  meter(
    'spouse',
    sp.email,
    `${sp.firstName || ''} ${sp.lastName || ''}`.trim(),
    es ? 'Conyuge' : 'Spouse',
  );

  (Array.isArray(client.dependents) ? client.dependents : []).forEach((d, i) => {
    if (!d) return;
    meter(
      d.id || `dep${i}`,
      d.email,
      `${d.firstName || ''} ${d.lastName || ''}`.trim(),
      es ? 'Dependiente' : 'Dependent',
    );
  });

  return salida;
}
